// extracted by mini-css-extract-plugin
export default {"root":"TabInvigilation_root__T6a2J","body":"TabInvigilation_body__ySqre","btnRow":"TabInvigilation_btnRow__y97M5"};